export const SHOW_ANALYSIS = 'SHOW_ANALYSIS';

export function showAnalysis(payload) {
  return {
    type: SHOW_ANALYSIS,
    payload,
  };
}
